"use client";
import dynamic from "next/dynamic";
const Cart = dynamic(() => import("@/app/components/catalog/Cart"), { ssr: false });
export default function CartPage() { return <Cart />; }
